// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1__dac5f192f9cff3c172da","cls2":"PostEngagementFollowPrompt-cls2___ee8bbc3c8b3fc5085e3 PostEngagementFollowPrompt-cls1__dac5f192f9cff3c172da"};